import { jsx as _jsx } from "react/jsx-runtime";
import { useViewDocumentQuery } from '../services/document';
const AuthenticatedImage = ({ documentId = '', placeholder, alt, className }) => {
    const { data: imageUrl } = useViewDocumentQuery(documentId, {
        skip: !documentId,
    });
    return (_jsx("img", { src: imageUrl || placeholder || '', alt: alt, className: className }));
};
export default AuthenticatedImage;
